import { Injectable } from '@angular/core';
import { APIService } from '@core/services/api.service';
import { Utility } from '@shared/services/utility.abstract';
import { BookingListRequest, BookingListResponse, BookingSummary } from '@core/models/booking.model';
import { ParkingLot } from '@core/models/api-response.model'; 
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})

export class BookingService {

  constructor(private readonly apiService: APIService) { }

  getBookingList(data: BookingListRequest){
    return this.apiService.post<BookingListResponse>('BookingSlot/GetBookingListByManagerId', data);
  }
  getBookingDetailById(bookingId: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<BookingSummary>(`BookingSlot/getBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
  }
  getParkingLotByStatesName(stateName: string): Observable<ParkingLot[]> {
    return this.apiService.get<ParkingLot[]>(`Dashboard/GetParkingLotByStatesName?state=${stateName}`);
  }
  getCheckInOutDetails( bookingId : string) {
    return this.apiService.get(`BookingSlot/GetCheckInOutDetails?bookingId=${bookingId}`)
  }
  sendInvoice(req){
    return this.apiService.post('BookingSlot/SendInvoiceOnMail',req)
  }
  viewInvoice(req){
    return this.apiService.post('BookingSlot/DownloadInvoice',req)
  }
  getGroupBookingList(request){
    return this.apiService.postWithAllResponse('GroupBooking/GetGroupBookingList', request)
  }
  getAssistedGroupBookingList(request){
    return this.apiService.postWithAllResponse('GroupBooking/GetAssistedGroupBookingList', request)
  }
  getGroupBookingDetailById(bookingId){
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get(`GroupBooking/GetGroupBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
  }
}

